module.exports = __webpack_public_path__ + "img/BDCIcon3.8f852983.png";